import { createContext, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getItem } from '../redux/actions/item';
import { useUser } from './UserContext';
import { useGlobal } from './GlobalContext';

const ItemContext = createContext({
   items: [],
   item: null,
});

export const useItem = () => useContext(ItemContext);

export const ItemProvider = ({ children }) => {
   const dispatch = useDispatch();
   const { user } = useUser();
   const { userGlobalSettingsData } = useGlobal();
   const authToken = localStorage.getItem('authTokenCustomer');
   const items = useSelector((state) => state.item?.list);

   const isItem = useMemo(() => {
      return userGlobalSettingsData?.[0]?.askCompany?.item || false;
   }, [userGlobalSettingsData]);

   useEffect(() => {
      if (user?.loginhistory?.companyId && authToken) {
         const payload = { companyId: user?.loginhistory?.companyId, sortBy: 'name', sortOrder: 'asc' };
         if (isItem) {
            payload.companyIds = user?.loginhistory?.companyId;
         }
         dispatch(getItem(payload));
      }
   }, [authToken, dispatch, user?.loginhistory?.companyId, isItem]);

   return <ItemContext.Provider value={{ items, item: null }}>{children}</ItemContext.Provider>;
};
